export default {
  labels: {
    card: 'Tarjeta de crédito',
    bank_account: 'Cuenta bancaria',
  },
  alerts: {
    payments_not_configured:
      'Los pagos aún no están configurados. Contacta con tu proveedor para habilitarlos y vuelve a este paso.',
  },
  buttons: {
    change_payment_method: 'Cambiar método de pago',
    save_payment_info: 'Guardar información de pago',
  },
  toasts: {
    failed_to_init_payment_setup: 'Error al iniciar el proceso de configuración de pago, recarga la página',
    successfully_saved_payment_method: 'Información de pago guardada',
  },
};
